import React, { useState, useRef, useEffect } from "react";
import DynamicForm from "f1-dynamic-form-react";
import Loader from "./../../components/loader/loader";
import { ACCOUNT_PRODUCT_FORM, customValidators } from "./../formData";
import { format } from "date-fns";

import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useNavigate } from "react-router-dom";
import { post } from "./../../api/api";
import axios from "axios";
import ModalPopup from "f1-modal-react";
import { Button } from "@material-ui/core";
import { useCallback } from "react";

import Webcam from "react-webcam";
import {
  ApiUrls
} from "./../../api/baseURL";
import useOnlineStatus from "./../../useOnlineStatus";
import {
  getAllAccountProductOffline
} from "./../../offlineManager/inventoryOffline";
import { getAllOfTable, add, removeAllAccountProducts } from "./../../offlineManager/localbase";
import { metaDataConstants } from "../../utils/Constants/constants-en";
import { getDateWithFormat } from "../../utils/utils";
import { getPhysicalInventoryCheckOffline } from "../../utils/utils";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
const dateFormate = "MM-dd-yyyy HH:mm:ss";

const AccountWiseProductDetail = () => {
  let dyFormRef = useRef();
  const dispatch = useDispatch();
  const store = useSelector(state => state);

  const webcamRef = useRef(null); // create a webcam reference
  const [imgSrc, setImgSrc] = useState(null);
  const [barcodeNo, setBarcodeNo] = useState(null);
  let naviagte = useNavigate();

  const [umoID, setUmoID] = useState(null);
  const capture = useCallback(async () => {
    setActivateLoader(true);
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);

    var result = imageSrc.substr(imageSrc.indexOf(",") + 1);
    const response = await axios.post(ApiUrls().PROCESSCODE_BY_FLASK_API, {
      base64: result,
    });
    if (response?.data == "Success") {
      setHideDuration(2000)
      setShowMessage(true);
      setStatus("error");
      setServityMessage(metaDataConstants.codeNotScanned);
    }
    if (response?.data.scannedCode) {
      setHideDuration(2000)
      setShowMessage(true);
      setStatus("success");
      setServityMessage(`barcode no is ${response?.data.scannedCode}`);
    }
    console.log(response, "server");
    setBarcodeNo(response?.data.scannedCode);
    setIsshowButton(false);
    setActivateLoader(false);
  }, [webcamRef]);

  const retake = () => {
    setImgSrc(null);
    setBarcodeNo(null);
    setIsshowButton(true);
  };
  const videoConstraints = {
    facingMode: "environment", // Use the rear camera
  };

  const [activateLoader, setActivateLoader] = useState(false);
  const [productForm, setProductForm] = useState(ACCOUNT_PRODUCT_FORM);
  const [barcodeData, setBarcodeData] = useState({
    barcodenumber: null,
    productid: null,
    productCode: null,
    productname: null,
    inventoryunit: null,
    previousquantity: null,
    unitprice: null,
    updatenewquaninty: '',
    vendorId: null,
  });
  const [show, setShow] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [status, setStatus] = useState("");
  const [servitymessage, setServityMessage] = useState("");
  const [serverityStatus, setServerityStatus] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalCamera, setShowModalCamera] = useState(false);
  const [modelHeaderContent, setModelHeaderContent] = useState("");
  const [isfirstvisit, setIsfirstvisit] = useState(true);
  const isOnline = useOnlineStatus();
  const [createdDate, setCreatedDate] = useState(
    getDateWithFormat(dateFormate)
  );
  const [isshow, setIsShow] = useState(true);
  const [isshowScan, setIsShowScan] = useState(true);
  const [unitTotalQuantityUOMId, setUnitTotalQuantityUOMId] = useState(0);
  const [hideDuration, setHideDuration] = useState(2000);


  const [isshowButton, setIsshowButton] = useState(true);
  const [current, setCurrent] = useState({
    barcodenumber: null,
    productid: null,
    productCode: null,
    productname: null,
    inventoryunit: null,
    previousquantity: null,
    unitprice: null,
    updatenewquaninty: '',
    Remarks: null,
  });

  const [umoId, setUmoId] = useState({
    uomId1: 0,
    uomEnteredStock1: 0,
    uomPreviousEnteredStock1: 0,
    uomId2: 0,
    uomEnteredStock2: 0,
    uomPreviousEnteredStock2: 0,
    uomId3: 0,
    uomEnteredStock3: 0,
    uomPreviousEnteredStock3: 0,
    uomId4: 0,
    uomEnteredStock4: 0,
    uomPreviousEnteredStock4: 0,
    uomId6: 0,
    uomEnteredStock6: 0,
    uomPreviousEnteredStock6: 0,
    firtstScan: false,
});

// Update function to maintain previous state
  const updateUmoId = (updates) => {
    setUmoId((prevUmoId) => {
      const newState = { ...prevUmoId };
      if (updates.firtstScan) {
        newState.firtstScan = false;
        Object.keys(updates).forEach((key) => {
          if (key.startsWith("uomEnteredStock")) {
            const prevKey = key.replace("uomEnteredStock", "uomPreviousEnteredStock");
            newState[prevKey] = updates[key];
          }
        });
      }
      return { ...newState, ...updates };
    });
  };

useEffect(() => {
    if (store.sync == true){
      getInventoryCheck().then(res => setActivateLoader(false)).catch(err => setActivateLoader(false));
      getInventoryCheckDetailOffline();
      setBarcodeData({
        ...barcodeData,
        barcodenumber: null,
        productid: null,
        productCode: null,
        productname: null,
        inventoryunit: null,
        previousquantity: null,
        unitprice: null,
        updatenewquaninty: '',
        vendorId: null
      });
      setCurrent({
        ...current,
        barcodenumber: '',
        productid: '',
        productCode: '',
        productname: '',
        inventoryunit: '',
        previousquantity: '',
        unitprice: '',
        updatenewquaninty: '',
        Remarks: '',
      });
      dispatch({type: 'RESET_SYNC'})
    }
  }, [store])

  useEffect(() => {
    const firstVisit = localStorage.getItem("isfirstvisit");
    const isofflineproductsadded = localStorage.getItem("isofflineaccproductsadded");
    const isOnlineSyncRequired = localStorage.getItem("isOnlineSyncRequired");
    if (isOnline && firstVisit == 1) {
      localStorage.setItem("isfirstvisit", 0);
    }
    if (isOnline && isofflineproductsadded != "true" && !isfirstvisit) {
      getInventoryCheck().then(res => setActivateLoader(false)).catch(err => setActivateLoader(false));
    }
    if (isOnlineSyncRequired == "true") {
      localStorage.setItem("isOnlineSyncRequired", false);
      getInventoryCheckDetailOffline()
    }
  }, [isOnline]);

  const [inventoryCheckData, setInventoryCheckData] = useState([]);
  const [productInventoryData, setProductInventoryData] = useState([]);
  const [inventoryCheckDataOffline, setInventoryCheckDataOffline] = useState([]);
  const [state, setState] = useState({
    activateLoader: false,
    show: false,
    serverityStatus: "",
    message: "",
  });
  const [barcodeDataDB, setBarcodeDataDB] = useState([]);
  // Data type: 'boolean', 'numeric', 'date', 'datetime', 'time', 'currency'
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
    setShowMessage(false);
  };

  const focusTextInput = () => {
    document.querySelector("#barcodenumber").focus();
  };

  useEffect(() => {
    localStorage.setItem("quantity", 0);
    getBarcodeData();
    getInventoryCheckDetailOffline();
    if (isOnline) {
      setActivateLoader(true);
      Promise.all([getInventoryCheck(), ProductSearchByInventoryAccount()]).then(() => {
        setActivateLoader(false);
      }).catch(() => {
        setActivateLoader(false);
      })
    }
    setIsfirstvisit(false);
    focusTextInput();
  }, []);

  const getBarcodeData = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable("BarcodeDetails")
        .then((res) => {
          resolve(res[0].barcodeDetails);
          setBarcodeDataDB(res[0].barcodeDetails);
        })
        .catch((err) => reject(false));
    });
  };

  const getInventoryCheck = async () => {
    const payload = {
      AccountId: localStorage.getItem("accountId"),
      ProductName: null,
      productId: 0,
      IsActive: 1,
      inventoryCheckAccountId: localStorage.getItem("inventoryCheckAccountId"),
      categoryId: 0,
    };

    setActivateLoader(true);
    const response = await post(ApiUrls().INVENTORY_COUNT, payload).catch(function (
      error
    ) {
      // Handle errors here
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      console.log(response?.data);
      setInventoryCheckData(response?.data.result);
      if (response?.data.result.length != 0) {
        setUnitTotalQuantityUOMId(
          response?.data.result[0]?.unitTotalQuantityUOMId
        );
      }
    }
  };

  const ProductSearchByInventoryAccount = async () => {
    const payload = {
      InventoryCheckAccountId: localStorage.getItem("inventoryCheckAccountId"),
      AccountId: localStorage.getItem("accountId"),
      IsActive: 1,
      SkipProductIds: '',
      take: 1000,
      skip: 0,
      page: 1,
      pageSize: 1000,
    };
    setActivateLoader(true);
    const response = await post(ApiUrls().PRODUCT_BY_INVENTORY_COUNT, payload, 'application/x-www-form-urlencoded; charset=UTF-8').catch(
      function (error) {
        // Handle errors here
        console.error("Error:", error);
      }
    );

    if (response?.status === 200) {
      setProductInventoryData(response?.data.result);
      if (response?.data.result.length != 0) {

      }
    }
  };
  const getInventoryCheckDetailOffline = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable("PhysicalInventoryDetails")
        .then((res) => {
          resolve(res[0].physicalInventoryDetails);
          setInventoryCheckDataOffline(res[0].physicalInventoryDetails);
        })
        .catch((err) => reject(false));
    });
  };

  const onSubmitHandler = async (model) => {
    if (model.productid !== null && model.productid !== "") {
      delete model.errors.productid;
    }
    if (model.previousquantity !== null && model.previousquantity !== "") {
      delete model.errors.previousquantity;
    }
    if (model.unitprice !== null && model.unitprice !== "") {
      delete model.errors.unitprice;
    }
    if (model.updatenewquaninty !== null && model.updatenewquaninty !== "") {
      delete model.errors.updatenewquaninty;
    }
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }
    if (
      model.productid === null ||
      model.productid == "" ||
      model.unitprice === null ||
      model.unitprice == "" ||
      model.inventoryunit === null ||
      model.inventoryunit == "" ||
      model.updatenewquaninty === null ||
      model.productname === null ||
      model.productname == "" ||
      model.updatenewquaninty == ""
    ) {
      setShow(true);
      setServerityStatus("error");
      setMessage(metaDataConstants.fillAllFields);
      return false;
    }
    setActivateLoader(true);
    if (isOnline) {
      let res;
      let totalQuantity;
      let unitTotalQuantityUOMId;
      let isConversionMissMatch;
      let productData;
      const storageID = localStorage.getItem("accountlocationStorageId");
      if (localStorage.getItem("inventoryType") === "Category Based") {
        res = inventoryCheckData?.filter(
          (ele) => ele.productId == model?.productid
        );
      } else {
        res = inventoryCheckData?.filter(
          (ele) =>
            ele.productId == model?.productid &&
            ele.locationStorageId == storageID
        );
      }

      if (localStorage.getItem("inventoryType") === "Category Based") {
        productData = productInventoryData?.filter(
          (ele) => ele.productId == model?.productid
        );
      } else {
        productData = productInventoryData?.filter(
          (ele) =>
            ele.productId == model?.productid &&
            ele.locationStorageId == storageID
        );
      }

      if (res.length > 0) {
        unitTotalQuantityUOMId = res[0]?.unitTotalQuantityUOMId
          ? res[0]?.unitTotalQuantityUOMId
          : 0;
        isConversionMissMatch = res[0]?.isConversionMissMatch;
        // calculating the total quantity of the product
        totalQuantity =
          umoId.uomEnteredStock1 *
          (res[0]?.uomConversion1 ? res[0]?.uomConversion1 : 0) +
          umoId.uomEnteredStock2 *
          (res[0]?.uomConversion2 ? res[0]?.uomConversion2 : 0) +
          umoId.uomEnteredStock3 *
          (res[0]?.uomConversion3 ? res[0]?.uomConversion3 : 0) +
          umoId.uomEnteredStock4 *
          (res[0]?.uomConversion4 ? res[0]?.uomConversion4 : 0) +
          umoId.uomEnteredStock6 *
          (res[0]?.uomConversion6 ? res[0]?.uomConversion6 : 0);
      } else if (productData.length > 0) {
        unitTotalQuantityUOMId = productData[0]?.unitTotalQuantityUOMId
          ? productData[0]?.unitTotalQuantityUOMId
          : 0;
        isConversionMissMatch = productData[0]?.isConversionMissMatch;
        // calculating the total quantity of the product
        totalQuantity =
          umoId.uomEnteredStock1 *
          (productData[0]?.uomConversion1
            ? productData[0]?.uomConversion1
            : 0) +
          umoId.uomEnteredStock2 *
          (productData[0]?.uomConversion2
            ? productData[0]?.uomConversion2
            : 0) +
          umoId.uomEnteredStock3 *
          (productData[0]?.uomConversion3
            ? productData[0]?.uomConversion3
            : 0) +
          umoId.uomEnteredStock4 *
          (productData[0]?.uomConversion4
            ? productData[0]?.uomConversion4
            : 0);
      } else {
        setActivateLoader(false);
        setShow(true);
        setServerityStatus("error");
        setMessage(metaDataConstants.productNotInAccountOrStorage);
        return false;
      }
      const ProductDetails = [
        {
          productId: model.productid,
          uomId1: umoId.uomId1 == null ? 0 : umoId.uomId1,
          uomEnteredStock1: umoId.uomEnteredStock1,
          uomPreviousEnteredStock1: umoId.uomPreviousEnteredStock1,
          uomId2: umoId.uomId2 == null ? 0 : umoId.uomId2,
          uomEnteredStock2: umoId.uomEnteredStock2,
          uomPreviousEnteredStock2: umoId.uomPreviousEnteredStock2,
          uomId3: umoId.uomId3 == null ? 0 : umoId.uomId3,
          uomEnteredStock3: umoId.uomEnteredStock3,
          uomPreviousEnteredStock3: umoId.uomPreviousEnteredStock3,
          uomId4: umoId.uomId4 == null ? 0 : umoId.uomId4,
          uomEnteredStock4: umoId.uomEnteredStock4,
          uomPreviousEnteredStock4: umoId.uomPreviousEnteredStock4,
          unitTotalQuantity: totalQuantity,
          unitTotalQuantityUOMId: unitTotalQuantityUOMId,
          isConversionMissMatch: isConversionMissMatch,
          locationStorageId: storageID,
        },
      ];
      const invCheckId = localStorage.getItem("inventoryCheckAccountId")
      const payload = {
        AccountId: localStorage.getItem("accountId"),
        InventoryCheckAccountId: invCheckId,
        IsLoadFromPrevious: false,
        IsSaveOnNext: false,
        ProductDetails,
     };
      const response = await post(ApiUrls().UPDATE_ACCOUNT_INVENTORY, payload).catch(
        function (error) {
          // Handle errors here
          localStorage.setItem("quantity", 0)
          setActivateLoader(false);
          if (error?.data?.message == "GNPWA01") {
            let countdown = 3;     // Countdown implementation
            const countdownInterval = setInterval(() => {
              if (countdown > 0) {
                setHideDuration(4000)
                setShowMessage(true);
                setStatus("info")
                setServityMessage(metaDataConstants.staleData.replace('countdown', countdown));
                countdown--;
              } else {
                clearInterval(countdownInterval);
                setHideDuration(2000)
                setShowMessage(true);
                setStatus("info")
                setServityMessage(metaDataConstants.syncingData);
                dispatch({ type: 'SYNC_REQUESTED' });
                setShowMessage(false);
              }
            }, 1000); // Update every second
          }
        }
      );
      if (response?.status === 200) {
        localStorage.setItem("quantity", 0);
        const updatedInvArray = inventoryCheckData.map(item => {
          if (item.productId == model.productid) {
            return {
             ...item,
              unitTotalQuantity: ProductDetails[0].unitTotalQuantity,
              uomEnteredStock1: ProductDetails[0].uomEnteredStock1,
              uomEnteredStock2: ProductDetails[0].uomEnteredStock2,
              uomEnteredStock3: ProductDetails[0].uomEnteredStock3,
              uomEnteredStock4: ProductDetails[0].uomEnteredStock4,
            };
          } else {
            return item;
          }
        })
        setInventoryCheckData(updatedInvArray)
        const physicalInventoryDetails = await getAllOfTable("PhysicalInventoryDetails")
        const updatedOfflineInvArray = physicalInventoryDetails[0].physicalInventoryDetails.map(item => {
          if (item.productId == model.productid && item.id == invCheckId) {
            return {
             ...item,
              unitTotalQuantity: ProductDetails[0].unitTotalQuantity,
              uomEnteredStock1: ProductDetails[0].uomEnteredStock1,
              uomEnteredStock2: ProductDetails[0].uomEnteredStock2,
              uomEnteredStock3: ProductDetails[0].uomEnteredStock3,
              uomEnteredStock4: ProductDetails[0].uomEnteredStock4
            };
          } else {
            return item;
          }
        })
        setInventoryCheckDataOffline(updatedOfflineInvArray)
        const dataObject = {
          physicalInventoryDetails: updatedOfflineInvArray,
        };
        add("PhysicalInventoryDetails", dataObject)
          .then((res) => {
            console.log(res)
            setActivateLoader(false)
            localStorage.setItem("isOnlineSyncRequired", true)
            // window.location.reload()
          })
          .catch((err) => console.log(err));
        setBarcodeData({
          barcodenumber: null,
          productid: null,
          productCode: null,
          productname: null,
          inventoryunit: null,
          previousquantity: null,
          unitprice: null,
          updatenewquaninty: '',
          vendorId: null,
        });
        setCurrent({
          ...current,
          barcodenumber: '',
          productid: '',
          productCode: '',
          productname: '',
          inventoryunit: '',
          previousquantity: '',
          unitprice: '',
          updatenewquaninty: '',
          Remarks: '',
        })
        setActivateLoader(false);
      } else {
        setActivateLoader(false);
      }
    } else {
      let res;
      let unitTotalQuantityUOMId;
      let isConversionMissMatch;
      const storageID = localStorage.getItem("accountlocationStorageId");
      const accountId = localStorage.getItem("accountId");
      const filterbyInvtoryCheckId = inventoryCheckDataOffline.filter((el) => el.id == localStorage.getItem("inventoryCheckAccountId"))

      if (localStorage.getItem("inventoryType") === "Category Based") {
        res = filterbyInvtoryCheckId?.filter(
          (ele) => ele.productId == model?.productid
        );
      } else {
        res = filterbyInvtoryCheckId?.filter(
          (ele) =>
            ele.productId == model?.productid &&
            ele.locationStorageId == storageID
        );
      }

      if (res.length > 0) {
        unitTotalQuantityUOMId = res[0]?.unitTotalQuantityUOMId
          ? res[0]?.unitTotalQuantityUOMId
          : 0;
        isConversionMissMatch = res[0]?.isConversionMissMatch;
        const totalQuantity =
          umoId.uomEnteredStock1 *
          (res[0]?.uomConversion1 ? res[0]?.uomConversion1 : 0) +
          umoId.uomEnteredStock2 *
          (res[0]?.uomConversion2 ? res[0]?.uomConversion2 : 0) +
          umoId.uomEnteredStock3 *
          (res[0]?.uomConversion3 ? res[0]?.uomConversion3 : 0) +
          umoId.uomEnteredStock4 *
          (res[0]?.uomConversion4 ? res[0]?.uomConversion4 : 0);

        const payload = {
          PhysicalProductName: model.productname,
          AccountId: accountId,
          InventoryCheckAccountId: localStorage.getItem(
            "inventoryCheckAccountId"
          ),
          IsLoadFromPrevious: false,
          IsSaveOnNext: false,
          productId: model.productid,
          uomId1: umoId.uomId1,
          uomEnteredStock1: umoId.uomEnteredStock1,
          uomPreviousEnteredStock1: umoId.uomPreviousEnteredStock1,
          uomId2: umoId.uomId2,
          uomEnteredStock2: umoId.uomEnteredStock2,
          uomPreviousEnteredStock2: umoId.uomPreviousEnteredStock2,
          uomId3: umoId.uomId3,
          uomEnteredStock3: umoId.uomEnteredStock3,
          uomPreviousEnteredStock3: umoId.uomPreviousEnteredStock3,
          uomId4: umoId.uomId4,
          uomEnteredStock4: umoId.uomEnteredStock4,
          uomPreviousEnteredStock4: umoId.uomPreviousEnteredStock4,
          unitTotalQuantity: totalQuantity,
          unitTotalQuantityUOMId: unitTotalQuantityUOMId,
          isConversionMissMatch: isConversionMissMatch,
          locationStorageId: storageID,
        };
        let accProducts = await getAllOfTable("AccountProducts");
        let existingProduct = false;
        let newArr = accProducts[0]?.accountProducts?.map((acc) => {
          if (acc.AccountId === accountId && acc.locationStorageId === payload.locationStorageId && acc.productId === payload.productId) {
            acc = payload
            existingProduct = true;
          }
          return acc;
        })
        const updatedPayload = existingProduct ? [...newArr] : newArr?.length > 0 ? [...newArr, payload] : [payload]
        accProducts && await removeAllAccountProducts()
        const dataObject = {
          accountProducts: updatedPayload,
        };
        add("AccountProducts", dataObject).then((res) => localStorage.setItem("isofflineaccproductsadded", true))
          .catch((err) => console.log(err));
        setModelHeaderContent(metaDataConstants.productSavedSuccess);
        window.location.reload();
      } else {
        setActivateLoader(false);
        setShow(true);
        setServerityStatus("error");
        setMessage(metaDataConstants.productNotInAccountOrStorage);
      }
      setActivateLoader(false);
    }
    focusTextInput();
  };

  const onKeyDownEvent = async (event,key,b,m) => {
    if (key === "barcodenumber") {
      if(event.key == 'Enter'){
        let newValue = event.target.value;
        if (barcodeData.barcodenumber === event.target.value) {
          setIsShowScan(false);
          const updatedQuantity = parseInt(localStorage.getItem("quantity"));
          setCurrent({
            ...current,
            barcodenumber: barcodeData.barcodenumber,
            productid: barcodeData.productid,
            productCode: barcodeData.productCode,
            productname: barcodeData.productname,
            inventoryunit: barcodeData.inventoryunit,
            previousquantity: barcodeData.previousquantity,
            unitprice: barcodeData.unitprice,
            updatenewquaninty: updatedQuantity || '',
          });
          const updatedQty = barcodeData.previousquantity + updatedQuantity  ;
          if (isOnline) {
            let result;
            let productData;
            const storageID = localStorage.getItem("accountlocationStorageId");
            if (localStorage.getItem("inventoryType") === "Category Based") {
              result = inventoryCheckData?.filter(
                (ele) => ele.productId == barcodeData.productid
              );
            } else {
              result = inventoryCheckData?.filter(
                (ele) =>
                  ele.productId == barcodeData.productid &&
                  ele.locationStorageId == storageID
              );
            }
            if (result.length > 0) {
              if (umoID == result[0]?.uomId1) {
                updateUmoId({uomEnteredStock1: updatedQty, firtstScan: true});
              } else if (umoID == result[0]?.uomId2) {
                updateUmoId({uomEnteredStock2: updatedQty, firtstScan: true });
              } else if (umoID == result[0]?.uomId3) {
                updateUmoId({uomEnteredStock3: updatedQty, firtstScan: true });
              } else if (umoID == result[0]?.uomId4) {
                updateUmoId({uomEnteredStock4: updatedQty, firtstScan: true });
              } else if (umoID == result[0]?.uomId5) {
                updateUmoId({uomEnteredStock6: updatedQty, firtstScan: true });
              } else if (umoID == result[0]?.uomId6) {
                updateUmoId({uomEnteredStock6: updatedQty, firtstScan: true });
              }
            } else {
              if (localStorage.getItem("inventoryType") === "Category Based") {
                productData = productInventoryData?.filter(
                  (ele) => ele.productId == barcodeData.productid
                );
              } else {
                productData = productInventoryData?.filter(
                  (ele) =>
                    ele.productId == barcodeData.productid &&
                    ele.locationStorageId == storageID
                );
              }
              if (umoID == productData[0]?.uomId1) {
                updateUmoId({ uomEnteredStock1: updatedQty, firtstScan: true });
              } else if (umoID == productData[0]?.uomId2) {
                updateUmoId({ uomEnteredStock2: updatedQty, firtstScan: true });
              } else if (umoID == productData[0]?.uomId3) {
                updateUmoId({ uomEnteredStock3: updatedQty, firtstScan: true });
              } else if (umoID == productData[0]?.uomId4) {
                updateUmoId({ uomEnteredStock4: updatedQty, firtstScan: true });
              } else if (umoID == productData[0]?.uomId5) {
                updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
              } else if (umoID == productData[0]?.uomId6) {
                updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
              }
            }
          } else {
            let result;
            const storageID = localStorage.getItem("accountlocationStorageId");
            const filterbyInvtoryCheckId = inventoryCheckDataOffline.filter((el) => el.id == localStorage.getItem("inventoryCheckAccountId"))
            if (localStorage.getItem("inventoryType") === "Category Based") {
              result = filterbyInvtoryCheckId?.filter(
                (ele) => ele.productId == barcodeData.productid
              );
            } else {
              result = filterbyInvtoryCheckId?.filter(
                (ele) =>
                  ele.productId == barcodeData.productid &&
                  ele.locationStorageId == storageID
              );
            }
            if (umoID == result[0]?.uomId1) {
              updateUmoId({uomEnteredStock1: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId2) {
              updateUmoId({ uomEnteredStock2: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId3) {
              updateUmoId({ uomEnteredStock3: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId4) {
              updateUmoId({ uomEnteredStock4: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId5) {
              updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId6) {
              updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
            }
          }
        } else {
          if (current.barcodenumber && event.target.value.length > current.barcodenumber.length + 5) {
            newValue = newValue.replace(current.barcodenumber, '')
          }
          handleInputChange(newValue);
        }
      }
    }
  };

  const handleInputChange = async (code) => {
    if (isOnline) {
      const payload = {
        UPCCode: code,
      };

      const response = await post(ApiUrls().SEARCH_PRODUCT_BY_UPCCODE, payload).catch(
        function (error) {
          // Handle errors here
          setActivateLoader(false);
          console.error("Error:", error);
          setBarcodeData({
            barcodenumber: null,
            productid: null,
            productCode: null,
            productname: null,
            inventoryunit: null,
            previousquantity: null,
            unitprice: null,
            updatenewquaninty: '',
            vendorId: null,
          });
          setCurrent({
            ...current,
            barcodenumber: '',
            productid: '',
            productCode: '',
            productname: '',
            inventoryunit: '',
            previousquantity: '',
            unitprice: '',
            updatenewquaninty: '',
            Remarks: '',
          })
        }
      );
      if (response?.status === 200) {
        setActivateLoader(false);

        if (response?.data.result.length > 0) {
          let res;
          const storageID = localStorage.getItem("accountlocationStorageId");
          if (localStorage.getItem("inventoryType") === "Category Based") {
            res = inventoryCheckData?.filter(
              (ele) => ele.productId == response?.data.result[0]?.productId
            );
          } else {
            res = inventoryCheckData?.filter(
              (ele) =>
                ele.productId == response?.data.result[0]?.productId &&
                ele.locationStorageId == storageID
            );
          }
          setUmoID(response?.data.result[0]?.uomId);
          const umoid = response?.data.result[0]?.uomId;
          let data;
          let productData;
          if (res.length > 0) {
            if (umoid == res[0]?.uomId1) {
              console.log(res[0]?.uomEnteredStock1);
              data = {
                previousquantity: res[0]?.uomEnteredStock1,
              };
              updateUmoId({
                uomId1: res[0]?.uomId1,
                uomEnteredStock1: res[0]?.uomEnteredStock1,
                uomId2: res[0]?.uomId2,
                uomEnteredStock2: res[0]?.uomEnteredStock2,
                uomId3: res[0]?.uomId3,
                uomEnteredStock3: res[0]?.uomEnteredStock3,
                uomId4: res[0]?.uomId4,
                uomEnteredStock4: res[0]?.uomEnteredStock4,
                uomId6: res[0]?.uomId6,
                uomEnteredStock6: res[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == res[0]?.uomId2) {
              data = {
                previousquantity: res[0]?.uomEnteredStock2,
              };
              updateUmoId({
                uomId1: res[0]?.uomId1,
                uomEnteredStock1: res[0]?.uomEnteredStock1,
                uomId2: res[0]?.uomId2,
                uomEnteredStock2: res[0]?.uomEnteredStock2  ,
                uomId3: res[0]?.uomId3,
                uomEnteredStock3: res[0]?.uomEnteredStock3,
                uomId4: res[0]?.uomId4,
                uomEnteredStock4: res[0]?.uomEnteredStock4,
                uomId6: res[0]?.uomId6,
                uomEnteredStock6: res[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == res[0]?.uomId3) {
              data = {
                previousquantity: res[0]?.uomEnteredStock3,
              };
              updateUmoId({
                uomId1: res[0]?.uomId1,
                uomEnteredStock1: res[0]?.uomEnteredStock1,
                uomId2: res[0]?.uomId2,
                uomEnteredStock2: res[0]?.uomEnteredStock2,
                uomId3: res[0]?.uomId3,
                uomEnteredStock3: res[0]?.uomEnteredStock3  ,
                uomId4: res[0]?.uomId4,
                uomEnteredStock4: res[0]?.uomEnteredStock4,
                uomId6: res[0]?.uomId6,
                uomEnteredStock6: res[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == res[0]?.uomId4) {
              data = {
                previousquantity: res[0]?.uomEnteredStock4,
              };
              updateUmoId({
                uomId1: res[0]?.uomId1,
                uomEnteredStock1: res[0]?.uomEnteredStock1,
                uomId2: res[0]?.uomId2,
                uomEnteredStock2: res[0]?.uomEnteredStock2,
                uomId3: res[0]?.uomId3,
                uomEnteredStock3: res[0]?.uomEnteredStock3,
                uomId4: res[0]?.uomId4,
                uomEnteredStock4: res[0]?.uomEnteredStock4  ,
                uomId6: res[0]?.uomId6,
                uomEnteredStock6: res[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == res[0]?.uomId5) {
              data = {
                previousquantity: res[0]?.uomEnteredStock5,
              };
              updateUmoId({
                uomId1: res[0]?.uomId1,
                uomEnteredStock1: res[0]?.uomEnteredStock1,
                uomId2: res[0]?.uomId2,
                uomEnteredStock2: res[0]?.uomEnteredStock2,
                uomId3: res[0]?.uomId3,
                uomEnteredStock3: res[0]?.uomEnteredStock3,
                uomId4: res[0]?.uomId4,
                uomEnteredStock4: res[0]?.uomEnteredStock4,
                uomId6: res[0]?.uomId6,
                uomEnteredStock6: res[0]?.uomEnteredStock6  ,
                firtstScan: true
              });
            } else if (umoid == res[0]?.uomId6) {
              data = {
                previousquantity: res[0]?.uomEnteredStock6,
              };
              updateUmoId({
                ...umoId,
                uomId1: res[0]?.uomId1,
                uomEnteredStock1: res[0]?.uomEnteredStock1,
                uomId2: res[0]?.uomId2,
                uomEnteredStock2: res[0]?.uomEnteredStock2,
                uomId3: res[0]?.uomId3,
                uomEnteredStock3: res[0]?.uomEnteredStock3,
                uomId4: res[0]?.uomId4,
                uomEnteredStock4: res[0]?.uomEnteredStock4,
                uomId6: res[0]?.uomId6,
                uomEnteredStock6: res[0]?.uomEnteredStock6  ,
                firtstScan: true
              });
            } else {
              data = {
                previousquantity: 0,
              };
            }
          } else {
            if (localStorage.getItem("inventoryType") === "Category Based") {
              productData = productInventoryData?.filter(
                (ele) => ele.productId == response?.data.result[0]?.productId
              );
            } else {
              productData = productInventoryData?.filter(
                (ele) =>
                  ele.productId == response?.data.result[0]?.productId &&
                  ele.locationStorageId == storageID
              );
            }
            if (umoid == productData[0]?.uomId1) {
              console.log(productData[0]?.uomEnteredStock1);
              data = {
                previousquantity: productData[0]?.uomEnteredStock1,
              };
              updateUmoId({
                ...umoId,
                uomId1: productData[0]?.uomId1,
                uomEnteredStock1: productData[0]?.uomEnteredStock1  ,
                uomId2: productData[0]?.uomId2,
                uomEnteredStock2: productData[0]?.uomEnteredStock2,
                uomId3: productData[0]?.uomId3,
                uomEnteredStock3: productData[0]?.uomEnteredStock3,
                uomId4: productData[0]?.uomId4,
                uomEnteredStock4: productData[0]?.uomEnteredStock4,
                uomId6: productData[0]?.uomId6,
                uomEnteredStock6: productData[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == productData[0]?.uomId2) {
              data = {
                previousquantity: productData[0]?.uomEnteredStock2,
              };
              updateUmoId({
                uomId1: productData[0]?.uomId1,
                uomEnteredStock1: productData[0]?.uomEnteredStock1,
                uomId2: productData[0]?.uomId2,
                uomEnteredStock2: productData[0]?.uomEnteredStock2  ,
                uomId3: productData[0]?.uomId3,
                uomEnteredStock3: productData[0]?.uomEnteredStock3,
                uomId4: productData[0]?.uomId4,
                uomEnteredStock4: productData[0]?.uomEnteredStock4,
                uomId6: productData[0]?.uomId6,
                uomEnteredStock6: productData[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == productData[0]?.uomId3) {
              data = {
                previousquantity: productData[0]?.uomEnteredStock3,
              };
              updateUmoId({
                uomId1: productData[0]?.uomId1,
                uomEnteredStock1: productData[0]?.uomEnteredStock1,
                uomId2: productData[0]?.uomId2,
                uomEnteredStock2: productData[0]?.uomEnteredStock2,
                uomId3: productData[0]?.uomId3,
                uomEnteredStock3: productData[0]?.uomEnteredStock3  ,
                uomId4: productData[0]?.uomId4,
                uomEnteredStock4: productData[0]?.uomEnteredStock4,
                uomId6: productData[0]?.uomId6,
                uomEnteredStock6: productData[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == productData[0]?.uomId4) {
              data = {
                previousquantity: productData[0]?.uomEnteredStock4,
              };
              updateUmoId({
                uomId1: productData[0]?.uomId1,
                uomEnteredStock1: productData[0]?.uomEnteredStock1,
                uomId2: productData[0]?.uomId2,
                uomEnteredStock2: productData[0]?.uomEnteredStock2,
                uomId3: productData[0]?.uomId3,
                uomEnteredStock3: productData[0]?.uomEnteredStock3,
                uomId4: productData[0]?.uomId4,
                uomEnteredStock4: productData[0]?.uomEnteredStock4  ,
                uomId6: productData[0]?.uomId6,
                uomEnteredStock6: productData[0]?.uomEnteredStock6,
                firtstScan: true
              });
            } else if (umoid == productData[0]?.uomId5) {
              data = {
                previousquantity: productData[0]?.uomEnteredStock5,
              };
              updateUmoId({
                uomId1: productData[0]?.uomId1,
                uomEnteredStock1: productData[0]?.uomEnteredStock1,
                uomId2: productData[0]?.uomId2,
                uomEnteredStock2: productData[0]?.uomEnteredStock2,
                uomId3: productData[0]?.uomId3,
                uomEnteredStock3: productData[0]?.uomEnteredStock3,
                uomId4: productData[0]?.uomId4,
                uomEnteredStock4: productData[0]?.uomEnteredStock4,
                uomId6: productData[0]?.uomId6,
                uomEnteredStock6: productData[0]?.uomEnteredStock6  ,
                firtstScan: true
              });
            } else if (umoid == productData[0]?.uomId6) {
              data = {
                previousquantity: productData[0]?.uomEnteredStock6,
              };
              updateUmoId({
                uomId1: productData[0]?.uomId1,
                uomEnteredStock1: productData[0]?.uomEnteredStock1,
                uomId2: productData[0]?.uomId2,
                uomEnteredStock2: productData[0]?.uomEnteredStock2,
                uomId3: productData[0]?.uomId3,
                uomEnteredStock3: productData[0]?.uomEnteredStock3,
                uomId4: productData[0]?.uomId4,
                uomEnteredStock4: productData[0]?.uomEnteredStock4,
                uomId6: productData[0]?.uomId6,
                uomEnteredStock6: productData[0]?.uomEnteredStock6  ,
                firtstScan: true
              });
            } else {
              data = {
                previousquantity: 0,
              };
            }
          }
          setIsShowScan(false);
          let price = response?.data.result[0]?.sellingPrice || 0;
          setBarcodeData({
            ...barcodeData,
            barcodenumber: code,
            productid: response?.data.result[0]?.productId,
            productCode: response?.data.result[0]?.productCode,   // need data in response
            productname: response?.data.result[0]?.productName,
            inventoryunit: response?.data.result[0]?.uomName,
            previousquantity: data.previousquantity,
            unitprice: `$${price}`,
            updatenewquaninty: '',
            vendorId: response?.data.result[0]?.vendorId,
          });
          setCurrent({
            ...current,
            barcodenumber: code,
            productid: response?.data.result[0]?.productId,
            productCode: response?.data.result[0]?.productCode,   // need data in response
            productname: response?.data.result[0]?.productName,
            inventoryunit: response?.data.result[0]?.uomName,
            previousquantity: data.previousquantity,
            unitprice: `$${parseFloat(price).toFixed(2)}`,
            updatenewquaninty: '',
          });
        } else {
          setCurrent({
            ...current,
            barcodenumber: '',
            productid: '',
            productCode: '',
            productname: '',
            inventoryunit: '',
            previousquantity: '',
            unitprice: '',
            updatenewquaninty: '',
            Remarks: '',
          })
          setBarcodeData({
            barcodenumber: null,
            productid: null,
            productCode: null,
            productname: null,
            inventoryunit: null,
            previousquantity: null,
            unitprice: null,
            updatenewquaninty: '',
            vendorId: null,
          });
          setShow(true);
          setIsShowScan(false)
          setServerityStatus("error");
          setMessage(metaDataConstants.unrecognizedCProduct);
        }
      } else {
        setActivateLoader(false);
      }
    } else {
      const response = barcodeDataDB.filter((ele) => ele.barcode == code);
      if (response?.length > 0 && response[0]?.barcode != "") {
        let UOMEnteredStock1;
        let UOMEnteredStock2;
        let UOMEnteredStock3;
        let UOMEnteredStock4;
        let UOMEnteredStock5;
        let UOMEnteredStock6;
        let isDataPresent = false;
        let res;
        const storageID = localStorage.getItem("accountlocationStorageId");
        const accountId = localStorage.getItem("accountId");
        const offline = await getAllAccountProductOffline();
        offline && offline[0]?.accountProducts.forEach(pr => {
          if (pr.AccountId === accountId && pr.locationStorageId === storageID && pr.productId === response[0].productId) {
            isDataPresent = true;
            UOMEnteredStock1 = pr?.uomEnteredStock1;
            UOMEnteredStock2 = pr?.uomEnteredStock2;
            UOMEnteredStock3 = pr?.uomEnteredStock3;
            UOMEnteredStock4 = pr?.uomEnteredStock4;
            UOMEnteredStock5 = pr?.uomEnteredStock5;
            UOMEnteredStock6 = pr?.uomEnteredStock6;
          }
        })

        const filterbyInvtoryCheckId = inventoryCheckDataOffline.filter((el) => el.id == localStorage.getItem("inventoryCheckAccountId"))
        if (localStorage.getItem("inventoryType") === "Category Based") {
          res = filterbyInvtoryCheckId?.filter(
            (ele) => ele.productId == response[0]?.productId
          );
        } else {
          res = filterbyInvtoryCheckId?.filter(
            (ele) =>
              ele.productId == response[0]?.productId &&
              ele.locationStorageId == storageID
          );
        }
        setUmoID(response[0]?.uomId);
        const umoid = response[0]?.uomId;
        let data;
        let productData;
        if (res.length > 0) {
          setUmoID(response[0]?.uomId);
          const umoid = response[0]?.uomId;
          if (umoid == res[0]?.uomId1) {
            data = {
              previousquantity:
                isDataPresent == true
                  ? UOMEnteredStock1
                  : res[0]?.uomEnteredStock1
                    ? res[0]?.uomEnteredStock1
                    : 0,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1:
                isDataPresent == true
                  ? UOMEnteredStock1  
                  : res[0]?.uomEnteredStock1
                    ? res[0]?.uomEnteredStock1  
                    : 0,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2:
                isDataPresent == true
                  ? UOMEnteredStock2
                  : res[0]?.uomEnteredStock2
                    ? res[0]?.uomEnteredStock2
                    : 0,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3:
                isDataPresent == true
                  ? UOMEnteredStock3
                  : res[0]?.uomEnteredStock3
                    ? res[0]?.uomEnteredStock3
                    : 0,
              uomId4: res[0]?.uomId4
                ? res[0]?.uomId4
                : 0,
              uomEnteredStock4:
                isDataPresent == true
                  ? UOMEnteredStock4
                  : res[0]?.uomEnteredStock4
                    ? res[0]?.uomEnteredStock4
                    : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6:
                isDataPresent == true
                  ? UOMEnteredStock6
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6
                    : 0,
            });
          } else if (umoid == res[0]?.uomId2) {
            data = {
              previousquantity:
                isDataPresent == true
                  ? UOMEnteredStock2
                  : res[0]?.uomEnteredStock2
                    ? res[0]?.uomEnteredStock2
                    : 0,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1:
                isDataPresent == true
                  ? UOMEnteredStock1
                  : res[0]?.uomEnteredStock1
                    ? res[0]?.uomEnteredStock1
                    : 0,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2:
                isDataPresent == true
                  ? UOMEnteredStock2  
                  : res[0]?.uomEnteredStock2
                    ? res[0]?.uomEnteredStock2  
                    : 0,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3:
                isDataPresent == true
                  ? UOMEnteredStock3
                  : res[0]?.uomEnteredStock3
                    ? res[0]?.uomEnteredStock3
                    : 0,
              uomId4: res[0]?.uomId4
                ? res[0]?.uomId4
                : 0,
              uomEnteredStock4:
                isDataPresent == true
                  ? UOMEnteredStock4
                  : res[0]?.uomEnteredStock4
                    ? res[0]?.uomEnteredStock4
                    : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6:
                isDataPresent == true
                  ? UOMEnteredStock6
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6
                    : 0,
            });
          } else if (umoid == res[0]?.uomId3) {
            data = {
              previousquantity:
                isDataPresent == true
                  ? UOMEnteredStock3
                  : res[0]?.uomEnteredStock3
                    ? res[0]?.uomEnteredStock3
                    : 0,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1:
                isDataPresent == true
                  ? UOMEnteredStock1
                  : res[0]?.uomEnteredStock1
                    ? res[0]?.uomEnteredStock1
                    : 0,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2:
                isDataPresent == true
                  ? UOMEnteredStock2
                  : res[0]?.uomEnteredStock2
                    ? res[0]?.uomEnteredStock2
                    : 0,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3:
                isDataPresent == true
                  ? UOMEnteredStock3  
                  : res[0]?.uomEnteredStock3
                    ? res[0]?.uomEnteredStock3  
                    : 0,
              uomId4: res[0]?.uomId4
                ? res[0]?.uomId4
                : 0,
              uomEnteredStock4:
                isDataPresent == true
                  ? UOMEnteredStock4
                  : res[0]?.uomEnteredStock4
                    ? res[0]?.uomEnteredStock4
                    : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6:
                isDataPresent == true
                  ? UOMEnteredStock6
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6
                    : 0,
            });
          } else if (umoid == res[0]?.uomId4) {
            data = {
              previousquantity:
                isDataPresent == true
                  ? UOMEnteredStock4
                  : res[0]?.uomEnteredStock4
                    ? res[0]?.uomEnteredStock4
                    : 0,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1:
                isDataPresent == true
                  ? UOMEnteredStock1
                  : res[0]?.uomEnteredStock1
                    ? res[0]?.uomEnteredStock1
                    : 0,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2:
                isDataPresent == true
                  ? UOMEnteredStock2
                  : res[0]?.uomEnteredStock2
                    ? res[0]?.uomEnteredStock2
                    : 0,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3:
                isDataPresent == true
                  ? UOMEnteredStock3
                  : res[0]?.uomEnteredStock3
                    ? res[0]?.uomEnteredStock3
                    : 0,
              uomId4: res[0]?.uomId4
                ? res[0]?.uomId4
                : 0,
              uomEnteredStock4:
                isDataPresent == true
                  ? UOMEnteredStock4  
                  : res[0]?.uomEnteredStock4
                    ? res[0]?.uomEnteredStock4  
                    : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6:
                isDataPresent == true
                  ? UOMEnteredStock6
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6
                    : 0,
            });
          } else if (umoid == res[0]?.uomId5) {
            data = {
              previousquantity:
                isDataPresent == true
                  ? UOMEnteredStock5
                  : res[0]?.uomEnteredStock5
                    ? res[0]?.uomEnteredStock5
                    : 0,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1:
                isDataPresent == true
                  ? UOMEnteredStock1
                  : res[0]?.uomEnteredStock1,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2:
                isDataPresent == true
                  ? UOMEnteredStock2
                  : res[0]?.uomEnteredStock2,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3:
                isDataPresent == true
                  ? UOMEnteredStock3
                  : res[0]?.uomEnteredStock3,
              uomId4: res[0]?.uomId4
                ? res[0]?.uomId4
                : 0,
              uomEnteredStock4:
                isDataPresent == true
                  ? UOMEnteredStock4
                  : res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6:
                isDataPresent == true
                  ? UOMEnteredStock6  
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6  
                    : 0,
            });
          } else if (umoid == res[0]?.uomId6) {
            data = {
              previousquantity:
                isDataPresent == true
                  ? UOMEnteredStock6
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6
                    : 0,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1:
                isDataPresent == true
                  ? UOMEnteredStock1
                  : res[0]?.uomEnteredStock1
                    ? res[0]?.uomEnteredStock1
                    : 0,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2:
                isDataPresent == true
                  ? UOMEnteredStock2
                  : res[0]?.uomEnteredStock2
                    ? res[0]?.uomEnteredStock2
                    : 0,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3:
                isDataPresent == true
                  ? UOMEnteredStock3
                  : res[0]?.uomEnteredStock3
                    ? res[0]?.uomEnteredStock3
                    : 0,
              uomId4: res[0]?.uomId4
                ? res[0]?.uomId4
                : 0,
              uomEnteredStock4:
                isDataPresent == true
                  ? UOMEnteredStock4
                  : res[0]?.uomEnteredStock4
                    ? res[0]?.uomEnteredStock4
                    : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6:
                isDataPresent == true
                  ? UOMEnteredStock6  
                  : res[0]?.uomEnteredStock6
                    ? res[0]?.uomEnteredStock6  
                    : 0,
            });
          } else {
            data = {
              previousquantity: 0,
            };
          }
          setIsShowScan(false);
        } else {
          if (localStorage.getItem("inventoryType") === "Category Based") {
            productData = productInventoryData?.filter(
              (ele) => ele.productId == response[0]?.productId
            );
          } else {
            productData = productInventoryData?.filter(
              (ele) =>
                ele.productId == response[0]?.productId &&
                ele.locationStorageId == storageID
            );
          }
          if (umoid == productData[0]?.uomId1) {
            console.log(productData[0]?.uomEnteredStock1);
            data = {
              previousquantity: productData[0]?.uomEnteredStock1,
            };
            updateUmoId({
              uomId1: productData[0]?.uomId1,
              uomEnteredStock1: productData[0]?.uomEnteredStock1  ,
              uomId2: productData[0]?.uomId2,
              uomEnteredStock2: productData[0]?.uomEnteredStock2,
              uomId3: productData[0]?.uomId3,
              uomEnteredStock3: productData[0]?.uomEnteredStock3,
              uomId4: productData[0]?.uomId4,
              uomEnteredStock4: productData[0]?.uomEnteredStock4,
              uomId6: productData[0]?.uomId6,
              uomEnteredStock6: productData[0]?.uomEnteredStock6,
            });
          } else if (umoid == productData[0]?.uomId2) {
            data = {
              previousquantity: productData[0]?.uomEnteredStock2,
            };
            updateUmoId({
              uomId1: productData[0]?.uomId1,
              uomEnteredStock1: productData[0]?.uomEnteredStock1,
              uomId2: productData[0]?.uomId2,
              uomEnteredStock2: productData[0]?.uomEnteredStock2  ,
              uomId3: productData[0]?.uomId3,
              uomEnteredStock3: productData[0]?.uomEnteredStock3,
              uomId4: productData[0]?.uomId4,
              uomEnteredStock4: productData[0]?.uomEnteredStock4,
              uomId6: productData[0]?.uomId6,
              uomEnteredStock6: productData[0]?.uomEnteredStock6,
            });
          } else if (umoid == productData[0]?.uomId3) {
            data = {
              previousquantity: productData[0]?.uomEnteredStock3,
            };
            updateUmoId({
              uomId1: productData[0]?.uomId1,
              uomEnteredStock1: productData[0]?.uomEnteredStock1,
              uomId2: productData[0]?.uomId2,
              uomEnteredStock2: productData[0]?.uomEnteredStock2,
              uomId3: productData[0]?.uomId3,
              uomEnteredStock3: productData[0]?.uomEnteredStock3  ,
              uomId4: productData[0]?.uomId4,
              uomEnteredStock4: productData[0]?.uomEnteredStock4,
              uomId6: productData[0]?.uomId6,
              uomEnteredStock6: productData[0]?.uomEnteredStock6,
            });
          } else if (umoid == productData[0]?.uomId4) {
            data = {
              previousquantity: productData[0]?.uomEnteredStock4,
            };
            updateUmoId({
              uomId1: productData[0]?.uomId1,
              uomEnteredStock1: productData[0]?.uomEnteredStock1,
              uomId2: productData[0]?.uomId2,
              uomEnteredStock2: productData[0]?.uomEnteredStock2,
              uomId3: productData[0]?.uomId3,
              uomEnteredStock3: productData[0]?.uomEnteredStock3,
              uomId4: productData[0]?.uomId4,
              uomEnteredStock4: productData[0]?.uomEnteredStock4  ,
              uomId6: productData[0]?.uomId6,
              uomEnteredStock6: productData[0]?.uomEnteredStock6,
            });
          } else if (umoid == productData[0]?.uomId5) {
            data = {
              previousquantity: productData[0]?.uomEnteredStock5,
            };
            updateUmoId({
              uomId1: productData[0]?.uomId1,
              uomEnteredStock1: productData[0]?.uomEnteredStock1,
              uomId2: productData[0]?.uomId2,
              uomEnteredStock2: productData[0]?.uomEnteredStock2,
              uomId3: productData[0]?.uomId3,
              uomEnteredStock3: productData[0]?.uomEnteredStock3,
              uomId4: productData[0]?.uomId4,
              uomEnteredStock4: productData[0]?.uomEnteredStock4,
              uomId6: productData[0]?.uomId6,
              uomEnteredStock6: productData[0]?.uomEnteredStock6  ,
            });
          } else if (umoid == productData[0]?.uomId6) {
            data = {
              previousquantity: productData[0]?.uomEnteredStock6,
            };
            updateUmoId({
              uomId1: productData[0]?.uomId1,
              uomEnteredStock1: productData[0]?.uomEnteredStock1,
              uomId2: productData[0]?.uomId2,
              uomEnteredStock2: productData[0]?.uomEnteredStock2,
              uomId3: productData[0]?.uomId3,
              uomEnteredStock3: productData[0]?.uomEnteredStock3,
              uomId4: productData[0]?.uomId4,
              uomEnteredStock4: productData[0]?.uomEnteredStock4,
              uomId6: productData[0]?.uomId6,
              uomEnteredStock6: productData[0]?.uomEnteredStock6  ,
            });
          } else {
            data = {
              previousquantity: 0,
            };
          }
        }
        let price = response[0]?.sellingPrice || 0;
        setIsShowScan(false);
        setBarcodeData({
          ...barcodeData,
          barcodenumber: code,
          productid: response[0]?.productId,
          productCode: response[0]?.productCode,
          productname: response[0]?.productName,
          inventoryunit: response[0]?.uomName,
          previousquantity: data.previousquantity,
          unitprice: `$${parseFloat(price).toFixed(2)}`,
          updatenewquaninty: '',
          vendorId: response[0]?.vendorId,
        });
        setCurrent({
          ...current,
          barcodenumber: code,
          productid: response[0]?.productId,
          productCode: response[0]?.productCode,
          productname: response[0]?.productName,
          inventoryunit: response[0]?.uomName,
          previousquantity: data.previousquantity,
          unitprice: `$${parseFloat(price).toFixed(2)}`,
          updatenewquaninty: '',
        });
      } else {
        setBarcodeData({
          barcodenumber: null,
          productid: null,
          productCode: null,
          productname: null,
          inventoryunit: null,
          previousquantity: null,
          unitprice: null,
          updatenewquaninty: '',
          vendorId: null,
        });
        setCurrent({
          ...current,
          barcodenumber: '',
          productid: '',
          productCode: '',
          productname: '',
          inventoryunit: '',
          previousquantity: '',
          unitprice: '',
          updatenewquaninty: '',
          Remarks: '',
        })
        setIsShowScan(false);
        setShow(true);
        setServerityStatus("error");
        setMessage(metaDataConstants.unrecognizedCProduct);
      }
    }
  };

  const onChangeHandler = async (event, key, model) => {
    if (key === "barcodenumber") {
      setCurrent({
        ...current,
        barcodenumber: event.target.value,
        productid: null,
        productCode: null,
        productname: null,
        inventoryunit: null,
        previousquantity: null,
        unitprice: null,
        updatenewquaninty: '',
      });
    }
    if (key === "updatenewquaninty") {
      const quantity = event.target.value;
      if (isOnline) {
        let res;
        let productData;
        const storageID = localStorage.getItem("accountlocationStorageId");
        if (localStorage.getItem("inventoryType") === "Category Based") {
          res = inventoryCheckData?.filter(
            (ele) => ele.productId == model?.productid
          );
        } else {
          res = inventoryCheckData?.filter(
            (ele) =>
              ele.productId == model?.productid &&
              ele.locationStorageId == storageID
          );
        }
        const updatedqty = barcodeData.previousquantity + parseFloat(quantity);
        if (res.length > 0) {
          if (umoID == res[0]?.uomId1) {
            updateUmoId({ uomEnteredStock1: updatedqty });
          } else if (umoID == res[0]?.uomId2) {
            updateUmoId({ uomEnteredStock2: updatedqty });
          } else if (umoID == res[0]?.uomId3) {
            updateUmoId({ uomEnteredStock3: updatedqty });
          } else if (umoID == res[0]?.uomId4) {
            updateUmoId({ uomEnteredStock4: updatedqty });
          } else if (umoID == res[0]?.uomId5) {
            updateUmoId({ uomEnteredStock6: updatedqty });
          } else if (umoID == res[0]?.uomId6) {
            updateUmoId({ uomEnteredStock6: updatedqty });
          }
        } else {
          if (localStorage.getItem("inventoryType") === "Category Based") {
            productData = productInventoryData?.filter(
              (ele) => ele.productId == barcodeData.productid
            );
          } else {
            productData = productInventoryData?.filter(
              (ele) =>
                ele.productId == barcodeData.productid &&
                ele.locationStorageId == storageID
            );
          }

          if (umoID == productData[0]?.uomId1) {
            updateUmoId({ uomEnteredStock1: updatedqty });
          } else if (umoID == productData[0]?.uomId2) {
            updateUmoId({ uomEnteredStock2: updatedqty });
          } else if (umoID == productData[0]?.uomId3) {
            updateUmoId({ uomEnteredStock3: updatedqty });
          } else if (umoID == productData[0]?.uomId4) {
            updateUmoId({ uomEnteredStock4: updatedqty });
          } else if (umoID == productData[0]?.uomId5) {
            updateUmoId({ uomEnteredStock6: updatedqty });
          } else if (umoID == productData[0]?.uomId6) {
            updateUmoId({ uomEnteredStock6: updatedqty });
          }
        }
      } else {
        let res;
        const storageID = localStorage.getItem("accountlocationStorageId");
        const filterbyInvtoryCheckId = inventoryCheckDataOffline.filter((el) => el.id == localStorage.getItem("inventoryCheckAccountId"))

        if (localStorage.getItem("inventoryType") === "Category Based") {
          res = filterbyInvtoryCheckId?.filter(
            (ele) => ele.productId == model.productid
          );
        } else {
          res = filterbyInvtoryCheckId?.filter(
            (ele) =>
              ele.productId == model.productid &&
              ele.locationStorageId == storageID
          );
        }
        const updatedqty = barcodeData.previousquantity + parseFloat(quantity);
        if (umoID == res[0]?.uomId1) {
          updateUmoId({ uomEnteredStock1: updatedqty });
        } else if (umoID == res[0]?.uomId2) {
          updateUmoId({ uomEnteredStock2: updatedqty });
        } else if (umoID == res[0]?.uomId3) {
          updateUmoId({ uomEnteredStock3: updatedqty });
        } else if (umoID == res[0]?.uomId4) {
          updateUmoId({ uomEnteredStock4: updatedqty });
        } else if (umoID == res[0]?.uomId5) {
          updateUmoId({ uomEnteredStock6: updatedqty });
        } else if (umoID == res[0]?.uomId6) {
          updateUmoId({ uomEnteredStock6: updatedqty });
        }
      }
      localStorage.setItem("quantity", parseInt(quantity));
      setCurrent({
        ...current,
        updatenewquaninty: quantity,
      });
    }
  };
  const onStay = () => {
    setShowModal(false);
    window.location.reload();
  };
  const gotoHome = () => {
    setShowModal(false);
    localStorage.removeItem("account");
    localStorage.removeItem("inventorydate");
    localStorage.removeItem("location");
    localStorage.removeItem("storageArea");
    localStorage.removeItem("inventoryduedate");
    localStorage.removeItem("inventorycounted");
    localStorage.removeItem("InventoryCheckId");
    localStorage.removeItem("LocationStorageId");
    localStorage.removeItem("labelData");
    naviagte(`/home`);
  };
  const onScanSameBarcode = () => {
    setCurrent({
      barcodenumber: "",
      productid: "",
      productCode: "",
      productname: "",
      inventoryunit: "",
      previousquantity: "",
      unitprice: "",
      updatenewquaninty: "",
      Remarks: "",
    });
    focusTextInput();
  };
  const onEnter = () => {
    console.log("onenter");
  };
  const onExit = (e) => {
    console.log("onexit");
  };
  const openCamera = () => {
    setIsshowButton(true);
    setShowModalCamera(true);
    setImgSrc(null);
  };
  const onClickBarcode = () => {
    if (barcodeData.barcodenumber === barcodeNo) {
      const updatedQuantity = parseInt(localStorage.getItem("quantity"));
      setCurrent({
        ...current,
        barcodenumber: barcodeData.barcodenumber,
        productid: barcodeData.productid,
        productCode: barcodeData.productCode,
        productname: barcodeData.productname,
        inventoryunit: barcodeData.inventoryunit,
        previousquantity: barcodeData.previousquantity,
        unitprice: barcodeData.unitprice,
        updatenewquaninty: updatedQuantity || '',
      });
      const updatedQty = barcodeData.previousquantity + updatedQuantity  ;
      if (isOnline) {
        let result;
        let productData;
        const storageID = localStorage.getItem("accountlocationStorageId");
        if (localStorage.getItem("inventoryType") === "Category Based") {
          result = inventoryCheckData?.filter(
            (ele) => ele.productId == barcodeData.productid
          );
        } else {
          result = inventoryCheckData?.filter(
            (ele) =>
              ele.productId == barcodeData.productid &&
              ele.locationStorageId == storageID
          );
        }
        if (result.length > 0) {
          if (umoID == result[0]?.uomId1) {
            updateUmoId({ uomEnteredStock1: updatedQty });
          } else if (umoID == result[0]?.uomId2) {
            updateUmoId({ uomEnteredStock2: updatedQty });
          } else if (umoID == result[0]?.uomId3) {
            updateUmoId({ uomEnteredStock3: updatedQty });
          } else if (umoID == result[0]?.uomId4) {
            updateUmoId({ uomEnteredStock4: updatedQty });
          } else if (umoID == result[0]?.uomId5) {
            updateUmoId({ uomEnteredStock6: updatedQty });
          } else if (umoID == result[0]?.uomId6) {
            updateUmoId({ uomEnteredStock6: updatedQty });
          }
        } else {
          if (localStorage.getItem("inventoryType") === "Category Based") {
            productData = productInventoryData?.filter(
              (ele) => ele.productId == barcodeData.productid
            );
          } else {
            productData = productInventoryData?.filter(
              (ele) =>
                ele.productId == barcodeData.productid &&
                ele.locationStorageId == storageID
            );
          }
          if (umoID == productData[0]?.uomId1) {
            updateUmoId({ uomEnteredStock1: updatedQty });
          } else if (umoID == productData[0]?.uomId2) {
            updateUmoId({ uomEnteredStock2: updatedQty });
          } else if (umoID == productData[0]?.uomId3) {
            updateUmoId({ uomEnteredStock3: updatedQty });
          } else if (umoID == productData[0]?.uomId4) {
            updateUmoId({ uomEnteredStock4: updatedQty });
          } else if (umoID == productData[0]?.uomId5) {
            updateUmoId({ uomEnteredStock6: updatedQty });
          } else if (umoID == productData[0]?.uomId6) {
            updateUmoId({ uomEnteredStock6: updatedQty });
          }
        }
      } else {
        let result;
        const storageID = localStorage.getItem("accountlocationStorageId");
        const filterbyInvtoryCheckId = inventoryCheckDataOffline.filter((el) => el.id == localStorage.getItem("inventoryCheckAccountId"))
        if (localStorage.getItem("inventoryType") === "Category Based") {
          result = filterbyInvtoryCheckId?.filter(
            (ele) => ele.productId == barcodeData.productid
          );
        } else {
          result = filterbyInvtoryCheckId?.filter(
            (ele) =>
              ele.productId == barcodeData.productid &&
              ele.locationStorageId == storageID
          );
        }
        if (umoID == result[0]?.uomId1) {
          updateUmoId({ uomEnteredStock1: updatedQty });
        } else if (umoID == result[0]?.uomId2) {
          updateUmoId({ uomEnteredStock2: updatedQty });
        } else if (umoID == result[0]?.uomId3) {
          updateUmoId({ uomEnteredStock3: updatedQty });
        } else if (umoID == result[0]?.uomId4) {
          updateUmoId({ uomEnteredStock4: updatedQty });
        } else if (umoID == result[0]?.uomId5) {
          updateUmoId({ uomEnteredStock6: updatedQty });
        } else if (umoID == result[0]?.uomId6) {
          updateUmoId({ uomEnteredStock6: updatedQty });
        }
      }
    } else if (barcodeData.barcodenumber != null) {
      setCurrent({
        ...current,
        barcodenumber: barcodeNo,
        productid: "",
        productCode: "",
        productname: "",
        inventoryunit: "",
        previousquantity: "",
        unitprice: "",
        updatenewquaninty: "",
      });
      setShow(true);
      setServerityStatus("warning");
      setMessage(
        metaDataConstants.submitPrevProdDetailsThenScan
      );
    } else {
      handleInputChange(barcodeNo);
    }
    setShowModalCamera(false);
    setImgSrc(null);
  };
  return (
    <>
      <Snackbar
        open={showMessage}
        autoHideDuration={hideDuration}
        onClose={() =>
          handleClose({
            vertical: "center",
            horizontal: "right",
          })
        }
      >
        <Alert severity={status}>{servitymessage}</Alert>
      </Snackbar>
      <Snackbar
        open={show}
        autoHideDuration={2000}
        onClose={() =>
          handleClose({
            vertical: "bottom",
            horizontal: "right",
          })
        }
      >
        <Alert severity={serverityStatus}>{message}</Alert>
      </Snackbar>

      <ModalPopup
        show={showModal}
        onHide={() => setShowModal(false)}
        size={"sm"}
        centered={true}
        modelHeader={modelHeaderContent}
        modelContent={
          <div className="footerButtons">
            <p> {metaDataConstants.wantToScanMoreProd}</p>
            <Button
              className="cancelBtn btn Ripple-parent btn btn-primary"
              onClick={onStay}
            >
              {metaDataConstants.yes}
            </Button>
            &nbsp;
            <Button
              className="btn-black btn Ripple-parent btn btn-primary"
              onClick={gotoHome}
            >
              {metaDataConstants.no}
            </Button>
          </div>
        }
        backdrop={"static"}
      />

      <ModalPopup
        show={showModalCamera}
        onHide={() => setShowModalCamera(false)}
        size={"lg"}
        centered={true}
        modelHeader={metaDataConstants.pointCameraAtBarcode}
        modelContent={
          <div className="divRound">
            <div className="clearfix"></div>
            {imgSrc ? (
              <img src={imgSrc} alt="webcam" />
            ) : (
              <Webcam
                className="webCameraDiv"
                videoConstraints={videoConstraints}
                height={500}
                width={600}
                ref={webcamRef}
              />
            )}
            <div className="btn-container">
              {imgSrc ? (
                <button className="btn btn-primary" onClick={retake}>
                  {metaDataConstants.retake}
                </button>
              ) : (
                <button className="btn btn-primary" onClick={capture}>
                  {metaDataConstants.capture}
                </button>
              )}
            </div>
            <Button
              className="cancelBtn btn Ripple-parent btn btn-primary"
              onClick={onClickBarcode}
              disabled={isshowButton}
            >
              {metaDataConstants.submit}
            </Button>
          </div>
        }
        backdrop={"static"}
        scrollable={true} //boolean
        onEnter={onEnter} //Callback fired before the Modal transitions in
        onExit={onExit} //Callback fired right before the Modal transitions out
        closeButtonShow={true}
        parentClassName="ModalBackground"
        headerClassName="ModalHeaderBackground"
        bodyClassName="ModalBodyBackground"
        footerClassName="ModalFooterBackground"
      />
      <div className="container containerMainDiv">
        <div className="contentdivBg p-0">
          <div className="divRound pt-3">
            <div className="clearfix"></div>
            <div className="formData text-left">
              <DynamicForm
                onRef={(ref) => {
                  dyFormRef.current = ref;
                }}
                key={1}
                className="dynamicForm"
                title={metaDataConstants.barcodeInvDetails}
                design="bootrstap"
                buttonSubmit={metaDataConstants.submit}
                model={productForm}
                defaultValues={current}
                materialOutline={false}
                disableSubmitOnInValid={!current.barcodenumber || !current.updatenewquaninty}
                onKeyDownText={onKeyDownEvent}
                customValidators={customValidators}
                showAstersikOnRequiredFields={true}
                buttonNormalClick={(id, key, obj) => openCamera(id, key, obj)}
                onSubmit={(model) => onSubmitHandler(model)}
                handleBlur={() => console.log("onblur")}
                onChange={(event, key, model) =>
                  onChangeHandler(event, key, model)
                }
              />
              <div className="lineBtnDiv">
                <Button
                  className="btn"
                  variant="contained"
                  disabled={isshowScan}
                  onClick={onScanSameBarcode}
                >
                  {metaDataConstants.scan}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader active={activateLoader} />
    </>
  );
};
export default AccountWiseProductDetail;
